import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49182e43"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "service-tags",
  class: "main-content-wrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title" }, "メニュータグ登録", -1))
const _hoisted_3 = { class: "w-full flex gap-3 justify-content-end pr-3" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "list-staff-body" }
const _hoisted_7 = { class: "w-full flex gap-3 justify-content-end pr-3" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-normal mb-2 block" }, [
  /*#__PURE__*/_createTextVNode("名前"),
  /*#__PURE__*/_createElementVNode("span", { class: "pl-1 text-red" }, "必須")
], -1))
const _hoisted_12 = {
  key: 1,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_13 = { class: "col-8" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-normal mb-2 block" }, [
  /*#__PURE__*/_createTextVNode("色"),
  /*#__PURE__*/_createElementVNode("span", { class: "pl-1 text-red" }, "必須")
], -1))
const _hoisted_15 = { class: "d-flex" }
const _hoisted_16 = {
  key: 0,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_17 = { class: "col-12 flex gap-3" }
const _hoisted_18 = ["for", "onClick"]
const _hoisted_19 = { class: "col-12 flex justify-content-center mt-2 gap-3" }

import { onBeforeMount, ref, inject, computed, watch } from "vue";
import { get, set } from "@vueuse/core";

// コンポーネントのインポート
import Header from "@/clinic/components/atoms/Grid/header.vue";
import Grid from "@/clinic/components/atoms/Grid/index.vue";
import Paginator from "@/clinic/components/atoms/Paginator/index.vue";

// PrimeVue関連のインポート
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";
import { useConfirm } from "primevue/useconfirm";
import ColorPicker from "primevue/colorpicker";
import RadioButton from "primevue/radiobutton";
import { PageState } from "primevue/paginator";

// サービスのインポート
import ServiceTagService from "@/clinic/services/service_tags.services";

// 定数のインポート
import { DEFAULT_PAGINATOR_ROWS } from "@/clinic/typings/constants/paginator";
import { PIN_TYPE, TAG_TYPE } from "@/clinic/typings/constants/service_tag";

// ユーティリティ関数のインポート
import { notityErrorMsg, notifySuccessMsg } from "@/clinic/utils/notify-utils";
import { useAsyncValidator } from "@vueuse/integrations/useAsyncValidator";

// バリデーションルールのインポート
import rules from "./rule";

/** 確認ダイアログのインスタンス */
type IColumn = {
  field: string;
  header: string;
  class?: string;
  style?: string;
  icon?: any;
};

/**
 * グリッドのカラム定義
 * タグID、名前、色、画面タイプ、アクションの5カラムを定義
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

/**
 * サービスタグ管理ページ
 * 固定タグと非固定タグの作成、編集、削除機能を提供する
 */

// Vue関連のインポート
const confirm = useConfirm();

/** ページあたりの表示件数 */
const rows = ref(DEFAULT_PAGINATOR_ROWS / 2);

/** 総件数 */
const totalCount = ref(0);

/** ページネーションの開始位置 */
const first = ref<number>(0);

/** 下部ページネーターのテンプレート参照 */
const pgBot = ref<InstanceType<typeof Paginator> | null>(null);

/** 検索キーワード */
const searchTerm = ref("");

/** クリニックID */
const clinicId = ref(0);

/** フォームダイアログの表示状態 */
const formVisible = ref(false);

/** 1つ目のタグ名 */
const firstTagName = ref("");

/** 2つ目のタグ名（固定タグ用） */
const secondTagName = ref("");

/** バリデーションエラー */
const errors = ref<any>({});

/**
 * デフォルトタグの設定
 * 新規作成時の初期値として使用
 */
const defaultTag = {
  id: null,
  name: "",
  color: "#000000",
  selected_type: 1,
  pin: PIN_TYPE.unpinned,
};

/** 選択中のタグ（編集用） */
const selectedTag = ref(defaultTag);

/** 非固定タグ一覧 */
const unpinnedServiceTags = ref<any[]>([]);

/** 固定タグ一覧 */
const pinnedServiceTags = ref<any[]>([]);

/**
 * 固定タグかどうかを判定
 * @returns {boolean} 固定タグの場合true
 */
const pinned = computed(() => get(selectedTag).pin == PIN_TYPE.pinned);

/**
 * 利用可能なタグタイプ
 * 固定タグの場合は単一タイプのみ、非固定タグの場合は全タイプ
 * @returns {Array} タグタイプの配列
 */
const tagTypes = computed(() => (get(pinned) ? [TAG_TYPE.single] : Object.values(TAG_TYPE)));

/**
 * ダイアログのヘッダー
 * 作成時と編集時で表示を切り替える
 * @returns {string} ダイアログヘッダー
 */
const dialogHeader = computed(() =>
  !get(selectedTag).id ? "タグを作成する" : get(pinned) ? "固定タグを編集する" : "タグを編集する"
);

/**
 * タグ名のプレースホルダー
 * 固定タグの場合は文字数制限を表示
 * @returns {string} プレースホルダーテキスト
 */
const tagNamePlaceholder = computed(() => (get(pinned) ? "4文字までを入力してください" : "タグ名を入力してください"));

/**
 * 選択中のタグのバリデーション状態
 * エラーがない場合にtrueを返す
 * @returns {boolean} バリデーション状態
 */
const validSelectedTag = computed(() => Object.keys(get(errors)).length === 0);

/**
 * 全サービスタグ一覧
 * 固定タグと非固定タグを結合
 * @returns {Array} 全タグの配列
 */
const serviceTags = computed(() => [...get(pinnedServiceTags), ...get(unpinnedServiceTags)]);

/**
 * 名前エラーの表示
 * 1つ目または2つ目のタグ名のエラーを表示
 * @returns {string} エラーメッセージ
 */
const nameError = computed(() => {
  const firstTagNameError = get(errors).firstTagName || [{ message: "" }];
  const secondTagNameError = get(errors).secondTagName || [{ message: "" }];

  return firstTagNameError[0].message || secondTagNameError[0].message;
});

/**
 * グリッドカラムの型定義
 */
const columns = ref<IColumn[]>([
  { field: "id", header: "タグID", class: "col-1" },
  { field: "name", header: "名前", class: "col-2", style: "white-space: pre" },
  { field: "color", header: "色", class: "col-3 pr-3" },
  { field: "selected_type_name", header: "画面タイプ" },
  { field: "actions", header: "" },
]);

/** トースト通知のインスタンス */
const toast = useToast();

/**
 * クリニックIDパラメータを取得
 * クリニックIDの型変換とデフォルト値設定を行う
 * @returns {Promise<{clinic_id: number}>} クリニックIDパラメータ
 */
const clinicIdParams = async () => {
  const clinic_id = get(clinicId);

  // clinic_idが数値であることを確認し、NaNの場合はデフォルト値を設定
  let actualClinicId;
  if (typeof clinic_id === "number" && !isNaN(clinic_id)) {
    actualClinicId = clinic_id;
  } else if (typeof clinic_id === "string" && clinic_id) {
    const parsed = Number(clinic_id);
    actualClinicId = isNaN(parsed) ? 1 : parsed; // NaNの場合はデフォルト値1を使用
  } else {
    actualClinicId = 1; // デフォルト値
  }

  return { clinic_id: actualClinicId };
};

/**
 * バリデーション処理
 * タグ名と色のバリデーションを実行
 */
const validate = async () => {
  const data = {
    firstTagName: get(firstTagName),
    secondTagName: get(secondTagName),
    color: get(selectedTag).color,
    pinned: get(pinned),
  };
  const initValidation = useAsyncValidator(data, rules(data));
  const { execute } = get(initValidation);
  const { errorFields } = await execute();
  errors.value = errorFields;
};

/**
 * タグ作成ダイアログを表示
 * @param {string} pin - 固定タグかどうかのフラグ
 */
const addTag = (pin: string) => {
  if (pin == PIN_TYPE.pinned && get(pinnedServiceTags).length >= 2) pin = PIN_TYPE.unpinned;
  set(selectedTag, { ...defaultTag, pin });
  set(firstTagName, "");
  set(secondTagName, "");
  set(formVisible, true);
};

/**
 * タグ編集ダイアログを表示
 * @param {number} tagId - タグID
 */
const editTag = (tagId: number) => {
  set(selectedTag, JSON.parse(JSON.stringify(get(serviceTags).find(tag => tag.id == tagId))));
  setTagName();
  set(formVisible, true);
  validate();
};

/**
 * タグ名を設定
 * 固定タグの場合は改行で分割して2つのフィールドに設定
 */
const setTagName = () => {
  if (get(pinned)) {
    const tagNames = get(selectedTag).name.split("\n");
    set(firstTagName, tagNames[0]);
    set(secondTagName, tagNames[1]);
  } else {
    set(firstTagName, get(selectedTag).name);
    set(secondTagName, "");
  }
};

/**
 * タグの削除処理
 * 確認ダイアログを表示し、承認時は削除APIを呼び出し
 * @param {number} tagId - タグID
 */
const deleteTag = async (tagId: number) => {
  confirm.require({
    defaultFocus: "",
    message: "このタグを削除しますか？",
    header: "タグの削除",
    rejectLabel: "キャンセル",
    acceptLabel: "削除",
    acceptClass: "p-button",
    accept: async () => {
      try {
        await ServiceTagService.destroyServiceTag(tagId, await clinicIdParams());
        await loadServiceTags();
        notifySuccessMsg(toast, "タグを正常に削除しました");
      } catch (error) {
        notityErrorMsg(toast, "タグの削除に失敗しました。しばらく時間をおいて再度お試しください。");
      }
    },
  });
};

/**
 * 検索処理
 * @param {any} event - 検索イベント
 */
const onSearch = async (event: any) => {
  set(searchTerm, event.currentTarget?.value);
  set(first, 0);
  await loadUnpinnedServiceTags();
};

/**
 * ページネーション処理
 * @param {string} _fromId - ページネーターのID
 * @param {PageState} pageState - ページ状態情報
 */
const paging = async (_fromId: string, { first: newFirst }: PageState) => {
  // 現在のfirstと同じ場合は何もしない
  if (newFirst === get(first)) {
    return;
  }

  // firstを更新してからAPIを呼び出し
  set(first, newFirst);
  await loadUnpinnedServiceTags();
};

/**
 * 全サービスタグを読み込み
 * 固定タグと非固定タグの両方を取得
 */
const loadServiceTags = async () => {
  await loadUnpinnedServiceTags();
  await loadPinnedServiceTags();
};

/**
 * 非固定サービスタグ一覧を取得
 * ページネーションと検索に対応
 */
const loadUnpinnedServiceTags = async () => {
  // firstからpageを計算（0ベースから1ベースに変換）
  const currentFirst = get(first);
  const currentRows = get(rows);
  const currentPage = Math.floor(currentFirst / currentRows) + 1;

  const params = {
    ...(await clinicIdParams()),
    page: currentPage,
    rows: currentRows,
    term: get(searchTerm),
    pin: PIN_TYPE.unpinned,
  };

  const { data } = await ServiceTagService.fetchServiceTag(params);
  const { service_tags: service_tags, meta } = get(data);
  const { total_count } = meta;
  set(unpinnedServiceTags, get(service_tags));
  set(totalCount, get(total_count));
};

/**
 * 固定サービスタグ一覧を取得
 */
const loadPinnedServiceTags = async () => {
  const { data } = await ServiceTagService.fetchServiceTag({
    ...(await clinicIdParams()),
    pin: PIN_TYPE.pinned,
  });
  set(pinnedServiceTags, get(data).service_tags);
};

/**
 * タグの保存処理
 * 作成または更新のAPIを呼び出し、成功時は一覧を再取得
 */
const handleSaveTag = async () => {
  await validate();

  const body = {
    name: `${get(firstTagName)}${get(pinned) ? `\n${get(secondTagName)}` : ""}`,
    color: get(selectedTag).color,
    selected_type: get(selectedTag).selected_type,
    pin: get(selectedTag).pin,
  };
  const params = { ...(await clinicIdParams()), id: get(selectedTag).id };
  await ServiceTagService.saveServiceTag(
    params,
    body,
    () => {
      notifySuccessMsg(toast, "タグは正常に保存されました。");
      set(formVisible, false);
      loadServiceTags();
    },
    (errors: any) => notityErrorMsg(toast, errors[0])
  );
};

/**
 * 色の変更を監視
 * #が付いていない場合は自動的に追加
 */
watch(
  () => get(selectedTag).color,
  (newColor: string) => set(selectedTag, { ...get(selectedTag), color: newColor.replace(/^([^#])/, "#$1") })
);

onBeforeMount(async () => {
  const injectedClinicId = await inject("clinicId");
  set(clinicId, injectedClinicId);
  await loadServiceTags();
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(Header, {
      onNew: _cache[0] || (_cache[0] = ($event: any) => (addTag(_unref(PIN_TYPE).pinned))),
      enableTitle: "",
      enableCreate: pinnedServiceTags.value.length < 2,
      createButtonLabel: "作成",
      titleLabel: "固定タグ設定",
      titleClass: "my-2"
    }, null, 8, ["enableCreate"]),
    _createVNode(Grid, {
      items: pinnedServiceTags.value,
      columns: columns.value
    }, {
      color: _withCtx(({ data }) => [
        _createElementVNode("div", {
          style: _normalizeStyle([{ 'background-color': data.color }]),
          class: "px-3 py-1 border-round-lg w-6rem text-center text-white text-sm uppercase white-space-nowrap"
        }, _toDisplayString(data.color), 5)
      ]),
      actions: _withCtx(({ data }) => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", {
            class: "pi pi-pencil text-green-600",
            onClick: ($event: any) => (editTag(data.id))
          }, null, 8, _hoisted_4),
          _createElementVNode("span", {
            class: "pi pi-trash text-red-600",
            onClick: ($event: any) => (deleteTag(data.id))
          }, null, 8, _hoisted_5)
        ])
      ]),
      _: 1
    }, 8, ["items", "columns"]),
    _createVNode(Header, {
      enableSearch: "",
      onSearch: onSearch,
      onNew: _cache[1] || (_cache[1] = ($event: any) => (addTag(_unref(PIN_TYPE).unpinned))),
      createButtonLabel: "作成",
      searchPlaceholder: "名前を入力",
      class: "mt-5"
    }),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(Grid, {
        items: unpinnedServiceTags.value,
        columns: columns.value
      }, {
        color: _withCtx(({ data }) => [
          _createElementVNode("div", {
            style: _normalizeStyle([{ 'background-color': data.color }]),
            class: "px-3 py-1 border-round-lg w-6rem text-center text-white text-sm uppercase white-space-nowrap"
          }, _toDisplayString(data.color), 5)
        ]),
        actions: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", {
              class: "pi pi-pencil text-green-600",
              onClick: ($event: any) => (editTag(data.id))
            }, null, 8, _hoisted_8),
            _createElementVNode("span", {
              class: "pi pi-trash text-red-600",
              onClick: ($event: any) => (deleteTag(data.id))
            }, null, 8, _hoisted_9)
          ])
        ]),
        _: 1
      }, 8, ["items", "columns"]),
      (totalCount.value > rows.value)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 0,
            id: "pg-bot",
            ref_key: "pgBot",
            ref: pgBot,
            first: first.value,
            "onUpdate:first": _cache[2] || (_cache[2] = ($event: any) => ((first).value = $event)),
            onPaging: paging,
            totalRecords: totalCount.value,
            rows: rows.value,
            class: "mt-2"
          }, null, 8, ["first", "totalRecords", "rows"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Toast), { position: "top-center" }),
    _createVNode(_component_Dialog, {
      visible: formVisible.value,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((formVisible).value = $event)),
      modal: "",
      header: _unref(dialogHeader),
      style: { width: '30vw' },
      draggable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_InputText, {
            class: "mb-2",
            modelValue: firstTagName.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((firstTagName).value = $event)),
            type: "text",
            placeholder: _unref(tagNamePlaceholder),
            onInput: validate
          }, null, 8, ["modelValue", "placeholder"]),
          (_unref(pinned))
            ? (_openBlock(), _createBlock(_component_InputText, {
                key: 0,
                modelValue: secondTagName.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((secondTagName).value = $event)),
                type: "text",
                placeholder: _unref(tagNamePlaceholder),
                onInput: validate
              }, null, 8, ["modelValue", "placeholder"]))
            : _createCommentVNode("", true),
          (_unref(nameError))
            ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_unref(nameError)), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: selectedTag.value.color,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedTag.value.color) = $event)),
              class: "mr-2",
              placeholder: "タグの色を入力してください",
              onInput: validate
            }, null, 8, ["modelValue"]),
            _createVNode(_unref(ColorPicker), {
              modelValue: selectedTag.value.color,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedTag.value.color) = $event))
            }, null, 8, ["modelValue"])
          ]),
          (errors.value?.color)
            ? (_openBlock(), _createElementBlock("small", _hoisted_16, _toDisplayString(errors.value?.color[0]?.message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tagTypes), (type) => {
            return (_openBlock(), _createElementBlock("div", {
              key: type.en_name,
              class: "flex align-items-baseline gap-1 cursor-pointer"
            }, [
              _createVNode(_unref(RadioButton), {
                modelValue: selectedTag.value.selected_type,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedTag.value.selected_type) = $event)),
                inputId: type.en_name,
                name: type.en_name,
                value: type.value
              }, null, 8, ["modelValue", "inputId", "name", "value"]),
              _createElementVNode("label", {
                for: type.en_name,
                class: _normalizeClass(["cursor-pointer", { 'text-orange': selectedTag.value.selected_type == type.value }]),
                onClick: ($event: any) => (selectedTag.value.selected_type = type.value)
              }, _toDisplayString(type.jp_name), 11, _hoisted_18)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_Button, {
            label: "キャンセル",
            class: "p-button-light",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (formVisible.value = false))
          }),
          _createVNode(_component_Button, {
            label: "保存",
            class: "btn-orange text-white",
            onClick: handleSaveTag,
            disabled: !_unref(validSelectedTag)
          }, null, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ]))
}
}

})